import { createLogger } from 'redux-logger'

import { esApi } from '@/__generated/es-api'
import config from '@/config'

import wsMiddleware from './ws-middleware'

const mwLogging = ['development', 'staging'].indexOf(config.env.app || '') > -1

const middlewares = [wsMiddleware, esApi.middleware]

if (mwLogging) {
  middlewares.push(
    createLogger({
      collapsed: true,
    }),
  )
}

export default middlewares
